// src/pages/cashier/AfricanCashierDashboard.jsx
import React from 'react';
import CashierDashboard from '../CashierDashboard';

const AfricanCashierDashboard = () => {
  return <CashierDashboard locationKey="african" />;
};

export default AfricanCashierDashboard;